import { Component, EventEmitter, Input, Output, ContentChildren, QueryList, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-dropdown',
  imports: [],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.scss'
})
export class DropdownComponent {
  @Input() label: string = 'Sort by:';
  @Input() id: string = 'sort-by';
  @Input() selectedValue: string = '';
  @Output() valueChanged = new EventEmitter<string>();

  onChange(event: Event) {
    const select = event.target as HTMLSelectElement;
    this.valueChanged.emit(select.value);
  }

}
